<template>
    <v-data-table
            :headers="headers"
            :items="companyTransactions"
            item-key="id"
            class="elevation-1 consent-table"
            :items-per-page="50"
            :options.sync="options"
            :footer-props="footerProps"
            :server-items-length="companyTransactionsCount"
    >
        <template v-slot:item="{ item }">
            <tr
                :key="`ct_${item.id}`"
                :class="`${item.transaction_type}-transaction`"
            >
                <td>{{ item.id ? item.id : '-' }}</td>
                <td>{{ item.entry_date ? item.entry_date : '-' }}</td>
                <td>{{ item.description ? item.description : '-' }}</td>
                <td>{{ item.amount ? item.amount.toFixed(2) : '-' }}</td>
                <td>{{ item.reference_number ? item.reference_number : "-" }}</td>
                <td>{{ item.swift ? swiftToBankName(item.swift) : "-" }}</td>
                <td>
                    <a class="payment-link" :style="{'color': getStatusColor(item.payment_status) }" v-if="item.payment_id" :href="`${api_url}/admin/payments-history/${item.payment_id}`">
                        {{item.payment_id}}
                    </a>
                    <span v-else>-</span>
                </td>
                <td style="text-align: right">
                    {{
                        Object.keys(companyBankAccountNames).includes(item.company_bank_account_id.toString()) ? companyBankAccountNames[item.company_bank_account_id.toString()] : "-"
                    }}
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import settings from "@/settings";
import {bankMixin} from "@/mixins/bank-mixin";
import {paymentColorMixin} from "@/mixins/payment-color-mixin";

export default {
    name: "company-transactions-table",
    mixins: [bankMixin, paymentColorMixin],
    data() {
        return {
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    value: 'id',
                },
                {text: 'Entry date', value: 'entry_date', align: 'start'},
                {text: 'Description', value: 'description', align: 'start'},
                {text: 'Amount', value: 'amount', align: 'start'},
                {text: 'Reference number', value: 'reference_number', align: 'start'},
                {text: 'Bank', value: 'swift', align: 'start'},
                {text: 'Related payment ID', value: 'payment_id', align: 'start'},
                {text: 'Account', value: 'company_bank_account_id', align: 'right'},
            ],
            footerProps: { "items-per-page-options": [10, 25, 50, 100] },
            api_url: settings.api_url,
            options: this.tableOptions
        }
    },
    computed: {
        ...mapState('ais', ['companyTransactions', 'companyBankAccountNames', 'tableOptions', 'companyTransactionsCount'])
    },
    watch: {
        async options(val) {
            await this.setTransactionTableOptions(val);
            await this.getCompanyTransactions();
        }
    },
    methods: {
        ...mapMutations('ais', ['setTransactionTableOptions']),
        ...mapActions('ais', ['getCompanyTransactions']),
    }
}
</script>

<style scoped lang="scss">
.consent-table {
    width: 100%;
}
.debit-transaction {
    background-color: #e1f9e1;
}
.credit-transaction {
    background-color: #f9e5e5;
}
.payment-link {
    text-decoration: none;
    color: black;
    font-weight: bold;
}
</style>